module.exports = "/_next/static/videos/hike-1-49d340fa2e9dab012d848e093de54d63.webm";